import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { TemplateResponse } from '../../models/template';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService extends BaseService {

  private templatesUrl = this.apiUrl + '/templates';

  /** GET Template by id. Will 404 if id not found */
  getTemplate(id: number): Observable<TemplateResponse> {
    if (+id === 0) {
      return of(this.initializeTemplate());
    }

    const url = `${this.templatesUrl}/${id}`;
    return this.http.get<TemplateResponse>(url).pipe(
      tap(_ => this.log(`fetched template id=${id}`)),
      catchError(this.handleError<TemplateResponse>(`getTemplate id=${id}`))
    );
  }

  /**
   *  Return an initialized object
   */
  initializeTemplate(): TemplateResponse {
    return new TemplateResponse();
  }

}
